/* eslint-env browser */
'use strict';

//var applicationServerPublicKey = 'BPxQr8ytRsv2uHQqtQAXL6GY0dWnRKb2c_QqyKJIK64K3Tc1FD4yKZjE41Mqy8gpfV_1uA5XElFGnpIvGeYbKAU';

const isSubscribed = false;
let swRegistration = null;

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw-shoppings-template.js')
      .then(reg => {
        swRegistration = reg;

        //handleSubscription();

        reg.onupdatefound = function () {
          // The updatefound event implies that reg.installing is set; see
          // https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
          const installingWorker = reg.installing;

          installingWorker.onstatechange = function () {
            switch (installingWorker.state) {
              case 'installed':
                if (navigator.serviceWorker.controller) {
                  // At this point, the old content will have been purged and the fresh content will
                  // have been added to the cache.
                  // It's the perfect time to display a "New content is available; please refresh."
                  // message in the page's interface.
                  console.log('New or updated content is available.');
                } else {
                  // At this point, everything has been precached.
                  // It's the perfect time to display a "Content is cached for offline use." message.
                  console.log('Content is now available offline!');
                }
                break;

              case 'redundant':
                console.error('The installing service worker became redundant.');
                break;
            }
          };
        };
      })
      .catch(e => {
        console.error('Error during service worker registration:', e);
      });
  });
}
/*
function handleSubscription() {
    //popup permissão push notification
    Notification.requestPermission().then(function(status) {
        if (status === 'granted') {
            swRegistration.pushManager.getSubscription()
                .then(function(subscription) {
                    if (!subscription) {
                        console.log('Not yet subscribed to Push');

                        isSubscribed = false;

                        subscribeUser();
                    }
                }).catch(function(err) {
                    console.log('Error during getSubscription()', err);
                });
        } 
        else if (status === 'denied' && localStorage.getItem('endpoint') != null) {
            unsubscribeUser();
        }
    })
}

function urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

function subscribeUser() {
    var subscribeParams = {
        userVisibleOnly: true
    };

    //seta a chave publica como parâmetro da inscrição
    var applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
    subscribeParams.applicationServerKey = applicationServerKey;

    swRegistration.pushManager.subscribe(subscribeParams)
        .then(function(subscription) {

            //obtem o endpoint da inscrição (geralmente um serviço do google)
            var endpoint = subscription.endpoint;
            
            localStorage.setItem('endpoint',endpoint);
            
            //chave e autorização para solicitar o push no endpoint
            var key = subscription.getKey('p256dh');
            var auth = subscription.getKey('auth');

            //envia a inscrição para o nosso server
            sendSubscriptionToServer(endpoint, key, auth);
            isSubscribed = true;
        })
        .catch(function(e) {
            // A problem occurred with the subscription.
            console.log('Unable to subscribe to push.', e);
        });
}

function unsubscribeUser() {
var endpoint = localStorage.getItem('endpoint')
    
    removeSubscriptionFromServer(endpoint);
    
    console.log('User is unsubscribed.');
    isSubscribed = false;
}

function sendSubscriptionToServer(endpoint, key, auth) {
    var encodedKey = btoa(String.fromCharCode.apply(null, new Uint8Array(key)));
    var encodedAuth = btoa(String.fromCharCode.apply(null, new Uint8Array(auth)));
    $.ajax({
        type: 'POST',
        url: '/subscription/subscribe',
        data: JSON.stringify({
            publicKey: encodedKey,
            auth: encodedAuth,
            notificationEndPoint: endpoint
        }),
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function(response) {
            console.log('Subscribed successfully!');
        },
        error: function(request, status, error) {
            console.log('There was an error to subscribe user:' + error);
        },
        dataType: 'json'

    });
}

function removeSubscriptionFromServer(endpoint) {
    $.ajax({
        type: 'POST',
        url: '/subscription/unsubscribe',
        data: JSON.stringify({
            notificationEndPoint: endpoint
        }),
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function(response) {
        	localStorage.removeItem('endpoint')
            console.log('Unsubscribed successfully! ');
        },
        error: function(error) {
            console.log('There was an error to unsubscribe user: ' + error);
        },
        dataType: 'json'
    });
}*/
